package com.zq.webproject.utils

import androidx.compose.runtime.Composable

/**
 * App 生命周期监听器（Web 平台）
 * Web 暂不支持，空实现
 */
@Composable
actual fun ObserveAppLifecycle(
    onResume: () -> Unit
) {
    // Web 平台暂不实现生命周期监听
}
